import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { withDefaults } from '../../utils/withDefaults';
import { spreadTypography } from '../../utils/typeUtils';
const BetaRoot = styled(Box)(({
  theme
}) => ({
  display: 'inline-flex',
  alignItems: 'center',
  boxSizing: 'border-box',
  color: theme.palette.common.white,
  padding: theme.spacing(0.25, 0.5),
  backgroundColor: theme.palette.secondary[500],
  borderRadius: theme.spacing(0.5),
  ...spreadTypography(theme.typography['Lato Overline Bold']),
  height: theme.spacing(2)
}));
export const Beta = withDefaults(BetaRoot, {
  role: 'button'
});